import React, { useCallback, useState, useEffect } from "react";
import { Box, Tooltip } from "@mui/material";
import debounce from "lodash/debounce";
import ReusableTable from "../../../components/custom/data_table/ReusableTable";
import { Badge } from "react-bootstrap";
import Loader from "../../../components/custom/Loader";
import { convertToBanglaNumerals } from "../../../utils/convertToBanglaNumerals";
import { useGetBanksListQuery } from "../../../redux/api/bankApiSlice";

const Banks = ({ showModal, setShowModal, editData, setEditData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const {
    data: fetchData,
    isLoading,
    refetch,
  } = useGetBanksListQuery({
    page: currentPage,
    name: searchValue,
  });

  const totalData = fetchData?.meta?.total;
  const lastPage = fetchData?.meta?.last_page;

  const debouncedSearch = useCallback(
    debounce((value) => {
      setCurrentPage(1);
      setSearchValue(value);
      refetch();
    }, 400),
    []
  );

  useEffect(() => {
    // Cleanup function to cancel the debounce when the component unmounts or debouncedSearch changes
    return () => {
      debouncedSearch?.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (value) => {
    setSearchText(value);
    debouncedSearch(value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    refetch();
  };

  const columns = [
    { label: "ক্রমিক নং", name: "si" },

    { label: "ব্যাংকের নাম", name: "name" },
    {
      label: "স্ট্যাটাস",
      name: "status",
      options: {
        customBodyRender: (value) => (
          <Badge bg={value === 1 ? "success" : "danger"}>
            {value === 1 ? "Active" : "In-active"}
          </Badge>
        ),
      },
    },

    {
      label: "ক্রিয়াকলাপ",
      name: "action",
      options: {
        customBodyRender: (value) => (
          <Box display={"flex"} gap={1}>
            <Tooltip title="Edit" placement="right" arrow>
              <Badge
                bg="warning"
                className="p-2"
                onClick={() => {
                  setEditData(value);
                  setShowModal(true);
                }}
                style={{ cursor: "pointer" }}
              >
                Edit
              </Badge>
            </Tooltip>
          </Box>
        ),
      },
    },
  ];

  const data = fetchData?.data.map((item, i) => ({
    si: convertToBanglaNumerals((currentPage - 1) * 15 + i + 1),
    id: item.id,
    name: item?.name,
    status: item?.status,
    action: {
      id: item.id,
      name: item?.name,
      status: item?.status,
    },
  }));

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="slideUp dashboard-layout p-4">
      <ReusableTable
        title={"ব্যাংকসমূহের নাম"}
        columns={columns}
        data={data}
        isLoading={isLoading}
        currentPage={currentPage}
        lastPage={lastPage}
        totalData={totalData}
        onSearchChange={handleSearchChange}
        searchText={searchText}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default Banks;
